import { isErrorResponse, getErrorFromErrorResponse } from '@standardnotes/responses';
import { Result } from '@standardnotes/domain-core';
export class GetInboundMessages {
    constructor(messageServer) {
        this.messageServer = messageServer;
    }
    async execute() {
        const response = await this.messageServer.getMessages();
        if (isErrorResponse(response)) {
            return Result.fail(getErrorFromErrorResponse(response).message);
        }
        return Result.ok(response.data.messages);
    }
}
